import * as React from "react";
import {DashboardNavbar} from "./DashboardNavbar";
import {IApplicationGuard, lazyInject, TypeDefs} from "@athena-portal/core";
import {WebChatPopUp} from "@ferry/plugin-ferry-journey";

export default class FalconHeader extends React.Component {

    @lazyInject(TypeDefs.ApplicationGuard)
    private applicationGuard: IApplicationGuard;

    public render() {
        const policyNumber = this.getPolicyNumberFromUrl();
        return (
            <React.Fragment>
                <WebChatPopUp policyNumber={policyNumber}/>
                <DashboardNavbar logout={this.doLogout}/>
            </React.Fragment>
        );
    }

    private doLogout = () => {
        history.pushState({}, "", "/dashboard");
        window.sessionStorage.clear();
        this.deleteCookie("registerUnauthenticated");
        this.applicationGuard.logout();
    };

    private deleteCookie(name: string): void {
        const appBaseUrl = window.location.hostname;
        let domain;
        if (appBaseUrl.includes("athenapaas.com")) {
            domain = "athenapaas.com";
        } else {
            domain = appBaseUrl;
        }
        document.cookie = name + "=;path=/;domain=" + domain + ";expires=Thu, 01-Jan-1970 00:00:01 GMT";
    }

    private getPolicyNumberFromUrl(): string {
        const url = window.location.href.replace(/\/$/, '');
        return url.slice(url.lastIndexOf('/') + 1);
    }
}
